module.exports = __webpack_public_path__ + "img/button_campaign.3acd7619.png";